import { render, staticRenderFns } from "./VehicleListView.vue?vue&type=template&id=19065804&"
import script from "./VehicleListView.vue?vue&type=script&lang=ts&"
export * from "./VehicleListView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports